import type { TranslationMessages } from '../types';

export const product_categories: TranslationMessages = {
  title: 'Product Categories',
  subtitle: 'Manage product categories for organizing your products',
  loading: 'Loading product categories...',
  new_category: 'New Category',
  search_placeholder: 'Search categories...',
  no_categories: 'No product categories yet. Create your first category!',
  no_results: 'No categories found matching your search.',
  load_error: 'Failed to load product categories',
  delete_confirm: 'Are you sure you want to delete this category?',
  delete_error: 'Failed to delete category. Please try again.',
  category_details: 'Category Details',
  name_placeholder: 'Enter category name...',
  edit_subtitle: 'Update category information',
  create_subtitle: 'Create a new product category',
  save_error: 'Failed to save category. Please try again.',
  view_grid: 'Table',
  view_tree: 'Tree',
  };
